import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Input, Form } from "antd";
import { useTranslation } from "react-i18next";

const CustomerName = ({ customers = [], form, name, value }) => {
    const [t] = useTranslation();

    const names = useMemo(() => customers.map(customer => customer.name), [customers]);

    return (
        <Form form={form} initialValues={{ [name]: value }}>
            <Form.Item
                name={name}
                rules={[
                    {
                        type: "string",
                        required: true,
                        message: t("t_customer_name_is_required")
                    },
                    {
                        message: t("t_customer_name_already_taken"),
                        validator: (_, currentValue) => {
                            if (currentValue === value) return Promise.resolve();
                            return names.includes(currentValue) ? Promise.reject() : Promise.resolve();
                        }
                    }
                ]}
            >
                <Input placeholder={t("t_customer_name_placeholder")} />
            </Form.Item>
        </Form>
    );
};

CustomerName.propTypes = {
    form: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string
};

export default CustomerName;
